import { Language } from 'interfaces/Language'
import BiologySubjectIcon from 'assets/homepage/subjects/homepage_subject_biology.svg'
import ChemistrySubjectIcon from 'assets/homepage/subjects/homepage_subject_chemistry.svg'
import EnglishSubjectIcon from 'assets/homepage/subjects/homepage_subject_english.svg'
import GermanSubjectIcon from 'assets/homepage/subjects/homepage_subject_german.svg'
import MathSubjectIcon from 'assets/homepage/subjects/homepage_subject_math.svg'
import HistorySubjectIcon from 'assets/homepage/subjects/homepage_subject_history.svg'
import FrenchSubjectIcon from 'assets/homepage/subjects/homepage_subject_french.svg'
import PolishSubjectIcon from 'assets/homepage/subjects/homepage_subject_polish.svg'
import WorldSubjectIcon from 'assets/homepage/subjects/homepage_subject_world.svg'

// Import black versions
import BiologySubjectIconBlack from 'assets/homepage/subjects/homepage_subject_biology_black.svg'
import ChemistrySubjectIconBlack from 'assets/homepage/subjects/homepage_subject_chemistry_black.svg'
import EnglishSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_english_black.svg'
import GermanSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_german_black.svg'
import MathSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_math_black.svg'
import HistorySubjectIconBlack from 'assets/homepage/subjects/homepage_subject_history_black.svg'
import FrenchSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_french_black.svg'
import PolishSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_polish_black.svg'
import WorldSubjectIconBlack from 'assets/homepage/subjects/homepage_subject_world_black.svg'

import theme from '../../stories/utils/theme'
import { ReactNode } from 'react'

export const getSubjectIcon = (iconType: string, isSelected = false): ReactNode => {
    switch (iconType) {
        case 'math':
            return isSelected ? <MathSubjectIconBlack /> : <MathSubjectIcon />
        case 'biology':
            return isSelected ? <BiologySubjectIconBlack /> : <BiologySubjectIcon />
        case 'chemistry':
            return isSelected ? <ChemistrySubjectIconBlack /> : <ChemistrySubjectIcon />
        case 'english':
            return isSelected ? <EnglishSubjectIconBlack /> : <EnglishSubjectIcon />
        case 'german':
            return isSelected ? <GermanSubjectIconBlack /> : <GermanSubjectIcon />
        case 'history':
            return isSelected ? <HistorySubjectIconBlack /> : <HistorySubjectIcon />
        case 'french':
            return isSelected ? <FrenchSubjectIconBlack /> : <FrenchSubjectIcon />
        case 'polish':
            return isSelected ? <PolishSubjectIconBlack /> : <PolishSubjectIcon />
        case 'world':
            return isSelected ? <WorldSubjectIconBlack /> : <WorldSubjectIcon />
        default:
            return null
    }
}

export interface HomepageSubject {
    titleKey?: string
    title?: string
    iconType: string
    knowUuids: string[]
    color: string
}

// For selection of knows for homepage, see https://metabase.knowunity.de/question/14698-beautiful-knows-selection-for-homepage?subject=Ciências%20Naturais&country=PT
export const returnSubjects = (contentLanguage: Language): HomepageSubject[] => {
    switch (contentLanguage) {
        case Language.French:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        'fa1f825b-2bcb-41f5-8472-7a382619398e',
                        '69adf12b-4c17-424e-a3cc-42736a2cb53a',
                        'dc3a2604-efd1-41ef-8fc7-97be5a4e2900',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectFrench',
                    iconType: 'french',
                    knowUuids: [
                        '55b0b656-cd59-499b-b2fb-30332cbd8288',
                        '5a5a2147-f7ab-4977-bba3-2978e63e1bc2',
                        '90ae9f40-0fe9-4131-a20c-528e5ac08c92',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        'b96fa80d-db8d-45f6-882c-90d455df00ad',
                        '399ecb40-078f-41e7-b95b-0ce3f5e576c8',
                        '1f4fcf86-8b08-4482-b7d3-efd51bd74928',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        'e5334f9d-3681-41bd-86b1-678bb5939c9a',
                        '9f563e8b-eac5-4167-b892-16bd0b27a286',
                        '35ab5325-f8fb-47af-8bcf-f4d618d96a73',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'dfc38b34-400c-4d4b-a496-508cc8ed7170',
                        '6a294d7b-4686-4da9-966b-39d5aa4b1df4',
                        '22e97a4d-ae1e-446e-80c2-d379af80457a',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '0b0dde7d-e33e-4b82-b02b-80992154fd78',
                        '0b0dde7d-e33e-4b82-b02b-80992154fd78',
                        '1beaa707-1119-4a3d-8994-2d85a93b3e41',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.Polish:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        'cfc56f69-e7a1-4122-b57d-0f849bea5961',
                        'b39477b9-da35-46fb-ae69-e2e68ef71134',
                        'e1baedd7-3185-432d-b12a-67236b9e9667',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectPolish',
                    iconType: 'polish',
                    knowUuids: [
                        'd73d3e9b-c9dd-49d6-b963-ad240777bedb',
                        '9f80d3a0-8245-405e-bd8c-f301a2b4e00e',
                        'e0a6fd34-16ea-4a62-93c2-54155bccae9f',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '4bc3f519-df65-4571-8a0b-5f87f89be07a',
                        '1b3eab13-4624-4fb4-b0a6-7e180cf098a2',
                        '6cc29d60-26f0-4e48-b183-de5a5cb56892',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '8403c6be-f7a3-412e-836e-44cd25416ab3',
                        '55f28ac6-f2e6-4389-8797-d55c91593168',
                        'bbd37c18-9753-4ae4-a8a8-ed183b85656c',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '23904171-9922-435e-83a1-8dc98bc95247',
                        'e2cd2671-7c3e-460f-9745-26a1b932a961',
                        '24365852-3ea9-4435-91d5-222bc57723f8',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        '963dd4b8-3333-4f1e-b134-fd551930d029',
                        '58c59ddd-48d3-4562-8289-4c2ac97c7eb0',
                        '3d09af8a-a5cb-476d-b029-d9141e906fcf',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.German:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: ['be6441c3-ab37-4786-8838-ed0276145652', '3732fdd2-43cd-46be-b4bd-bbd5154ed0b6'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectGerman',
                    iconType: 'german',
                    knowUuids: [
                        'd45b1cd0-7899-4aca-b426-1daf61cb14bf',
                        'e870daff-1b55-47bb-ad81-1197021430cc',
                        '1956a1f9-b410-4ee1-8868-a3aa3cff4c94',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '61d4b708-85cc-4611-89e9-b1de5d5540a4',
                        'dc34ac3c-c34d-4878-b9e9-68a94dc6f5bd',
                        '9634b597-1257-41ac-9ac7-3dd1c135cd40',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        'adc94501-6e48-4bdd-a165-7a73e0d503ac',
                        'f355f4e6-fdbf-4529-955d-383ea238f6c2',
                        '3ef3c499-951d-4574-8519-fb6ab515fd77',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: ['42e612f1-ff01-4cb3-ac56-95871a9df099', '550995c0-bb42-4b44-9c11-0b1344847a7c'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '97c129ea-f742-43b3-9e77-be49b9cdcc5e',
                        'e5b697a7-a321-473b-87b3-453c8403909e',
                        '42e612f1-ff01-4cb3-ac56-95871a9df099',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.AmericanEnglish:
            return [
                {
                    title: 'Algebra I',
                    iconType: 'math',
                    knowUuids: [
                        '3bd1004d-f942-4715-b86e-5be75f396deb',
                        '6806f689-dd77-4254-a86a-28c0518f88c1',
                        'bf91dbb4-cfb4-49b6-ae96-854c068a9db1',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    title: 'Biology',
                    iconType: 'biology',
                    knowUuids: [
                        '7647f55d-8f5e-48d0-a087-75e2c3515d71',
                        '20bfb4e3-2150-4123-92d4-b6995703d6e7',
                        'f98de35d-c70b-4b03-a485-e083074aac56',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    title: 'US History',
                    iconType: 'history',
                    knowUuids: ['f2327f59-a28e-4c43-9308-d80df635f95c'],
                    color: theme.colors.subjectYellow,
                },
                {
                    title: 'Geometry',
                    iconType: 'math',
                    knowUuids: [
                        '6a994cb5-6ea1-42da-b11d-ced531c7c865',
                        'ab15bdb5-11fa-47be-9480-a02731f1e2bd',
                        'e60882e0-db11-4f8e-9811-26a0c992ba93',
                    ],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.BritishEnglish:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        'c032f6ed-9981-42ac-86a8-f3a99479b51b',
                        'd4edcf83-bd9f-4faf-9949-ad7e2f000cd4',
                        '7d4f346c-48f8-4572-896c-0831a340b7da',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'b8a22df6-f88c-426b-bc8f-9e2f8a42c7a6',
                        '496d72da-9c02-4ee2-91aa-b5d9fed4ed6a',
                        '3295fb41-87c3-44bb-bc21-cb998aa66503',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '652b7fc4-a3db-4cf9-894b-7f3cf649619a',
                        'e05e5ce1-b3d1-4ac5-b3ae-d7ab291c9d52',
                        'be41b9ae-35e5-4e12-9a4c-474c30ae8251',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '19aac960-44ae-44b2-a457-ae6fe32fe8e1',
                        '6a4d03b9-4d7b-4e0d-a78b-e3b9921acbde',
                        'f03ec829-4eaf-4fd5-939d-975414a909bd',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'd94bcd05-2619-49c3-9452-92687b37506c',
                        '506044c4-fa7c-406b-b785-892712774ade',
                        '602c6067-7173-4419-9146-94c5103c8643',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.Italian:
            return [
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'b6e9ce7f-c187-4fa0-8852-7207bb3511ac',
                        'de0cb766-5e00-48b2-b239-df864e98128c',
                        '53868093-221c-48c7-927f-aebe97cdfe9d',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '51f32b97-1188-4906-8942-d7f0a4d90635',
                        'ecd19228-d528-44e1-879d-4b89ed3bc20d',
                        '38181b42-2209-49ac-ba0c-b950d844245a',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'ce75ea45-da1d-4302-a49e-d3da5ef5c1da',
                        'd597cfe3-0abc-468a-b713-70b0255cb4bd',
                        'fbff89e4-dd39-4195-80c0-902889af25a8',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '7665b05e-dd94-422b-a397-7925fdd52b68',
                        '22023c21-7dbd-450b-bfe3-56716768fbe8',
                        '7735612e-f0fb-465f-b8f3-e43af5623a4f',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        'd8eb53bd-87ea-4c4d-b907-6d273e0952c6',
                        '1fa34091-b973-4765-a13a-3fcfcfbf79c3',
                        '7b37ed19-0a27-4929-be60-e572ec90e2dd',
                    ],
                    color: theme.colors.subjectYellow,
                },
            ]
        case Language.ColombianSpanish:
            return [
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'ff01863b-8d00-45f3-a0f5-b3ee914c5b15',
                        '22345791-dc60-477c-80b1-811ee58caf29',
                        '1274ce12-1e98-444d-83ab-6829abf5df10',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: ['0ccb798c-3398-400e-8bcc-14942155178b'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: ['0cb625d5-2e1f-4c93-b984-7a2faba0c1c5'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: ['dfa75bab-2682-4a22-b339-3014764a481b'],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.Turkish:
            return [
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'a99304a0-2d0c-4e77-b2d1-0144bba902f4',
                        '8b2b0a7b-f6d1-4fe1-9d73-31142b954426',
                        '12f01d2b-e514-4420-b80b-b7b8089c170a',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        'd52c4a35-2173-40a1-b2d7-6ed3d65cf49d',
                        '406c8ac2-29e3-41bc-97e8-f770ae500ae1',
                        'a1f946e1-31bc-4f60-b82a-170c1ecc7ba7',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'ca3e7ba6-36ab-49a3-aee7-ea7024355798',
                        '9cff34b0-0b82-4b4a-9e81-b9280d0a462d',
                        'd0eddaa6-74da-479f-9cc7-e50f6683c862',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectTurkish',
                    iconType: 'world',
                    knowUuids: [
                        'd10f5237-8da2-4fe6-9557-f37805bbd38b',
                        'c3e99b44-1b59-4128-acd2-77d6e685fce5',
                        'd9e14aa6-ef21-4e19-a48a-3bf510f95c9e',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        'b684c7f3-2cce-4ce8-a677-19a60040fe80',
                        '10771f6d-d72b-451f-ba93-faa59570de5c',
                        'd11d6e0a-e820-43be-b7e0-856e6b9a997e',
                    ],
                    color: theme.colors.subjectYellow,
                },
            ]
        case Language.Spanish:
            return [
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'b3909402-fc7f-42c0-95b7-14e73c81d886',
                        '24279bde-bd26-42a0-8dc8-06fb28e2c470',
                        '9815f2a2-de76-4553-8ab0-9a57596ed35a',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: ['12ed7599-436e-484b-9f79-19a838e410e9'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: ['b521d420-4c0d-4e2a-83cf-de9c738f5c4c'],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: ['f4ece2bc-7e22-4a00-9bde-1d82911c7b9c'],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.ArgentineSpanish:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '1e3afb79-2bc6-4cf4-abf4-9301782bb5a1',
                        'a80a2dbc-2017-4919-992e-889f2f252ca5',
                        'af6918b3-972c-4473-af0d-cb9e2c1c365b',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '50fc4a48-a3c9-4de6-b71b-922275e36523',
                        '9842f44b-e0fd-4494-a32a-33982e2a3d9a',
                        '2a52fe3e-3047-46e3-8b84-262276d4c6c9',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        '1ece0656-dc43-4fce-9154-ad7e2de42f62',
                        '57eac5b8-c752-4401-a986-7bcfe6801a83',
                        'a6dd3c01-68db-40cd-b1aa-5e0a76e43d28',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.ChileanSpanish:
            return [
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '7975a487-9cbe-459e-8f92-acb19d39de23',
                        '5d238f45-9d78-42b1-ad75-091154e412c4',
                        'c5c8c719-d8b5-4b60-9443-707a045843ee',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: ['99967de6-83cf-43b3-80ba-18bbfb00b9a3', 'bbac2307-7028-4772-a55e-d9d51c46299b'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: ['c8543733-12fe-4889-8f71-37d5272f5df4'],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '3628cf6c-f7f4-4b9e-8398-f9ec0f8bcbe6',
                        'e1989d1a-7ac3-4e8b-91e8-4cdc07a36923',
                        'f3f8e0a8-0d4a-4133-b0e9-d5fb48d2eb2f',
                    ],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.PeruvianSpanish:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '9200fb86-e593-4f87-9f70-2878da4cfbd8',
                        '674a778d-f6d3-44cc-aa1d-69fe32b882e6',
                        '407b78a6-a1c0-4500-90d1-9bfded60c29e',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'f1b6a396-2f4e-49af-a461-8764704490f9',
                        '6f7fda4c-cdec-430b-b926-acdd992c663b',
                        'fb6edcfd-f54b-40f6-a01d-439d73dc0f6f',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'bb9fbbe6-c964-482d-a475-ebb95a343741',
                        '40fcdb18-ea35-4db3-aa22-f8b57a8e93fc',
                        '489004df-c79f-4f6d-9841-c8248d81a826',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.MexicanSpanish:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '278367de-a65b-4340-84b8-e377fb891dee',
                        '29a529f9-01ed-4d22-b7cd-0b10028b36e5',
                        '5cd3876c-f6ff-4ea2-b99c-561dbb345812',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '6a1e837d-0011-4e9a-9650-be779efa09e5',
                        'de1c2f76-2ed8-46ba-a5ea-dc220b42074b',
                        'cc6e8161-25bb-4dd5-a4b5-776753956c48',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '199349a6-d4e2-417f-8855-57619e07c03f',
                        '0d28d22b-6039-4863-9490-c53e5935f03e',
                        '57238188-ace2-4be3-a32d-dfc72566fce2',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '9b1eff82-13d9-4b13-8097-f5151b0fa539',
                        '48697cdf-8494-48c7-acca-32d298f07bd9',
                        '5dc87bad-fbd7-4ae8-b5cd-d7f72e015ebe',
                    ],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.Greek:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        'f0e86613-1797-43a9-9a0c-963882bb68d3',
                        '9a8eff48-a335-411e-8c00-8a84b8dcc6f9',
                        '35253ad1-7ec1-4dcb-a7b1-79fc917f7916',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '3ff2e98c-6e82-4d16-8f6e-ccea5a437526',
                        'aa0d8a53-0968-46a5-8e82-6bb2bac14139',
                        '6e0fe360-ae48-44c4-9b6b-67118b3d5f21',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'e51d4e1d-68f2-4e98-b082-1f32196fa87f',
                        '4e3ad583-204b-4484-8cf7-b6ac768bc12e',
                        'd5a61cfb-1087-4d75-b18d-d70c0d5ee7b8',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        '1029be01-6044-4df0-ba4c-f85072b7e3ae',
                        '9ada7233-9d25-41f3-acd7-988e8876cd6b',
                        '72befaa9-a74c-4c25-9313-13d02797c6dc',
                    ],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.Romanian:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '41426c4e-a9cc-412b-a18f-1b3d24b601ae',
                        '5998fff2-1863-4ead-a05e-c3d7b9ce52f3',
                        '770c56e3-b09f-4ec9-9763-8fb16c08e446',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'f9a6ee74-83eb-408b-8c43-3b03ad222521',
                        '24235ccf-61a6-4770-8aca-14b001af8494',
                        'c298940d-a3ff-4238-a691-58c48361cd7d',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '9b3b5a44-c05c-40bb-b78d-5b6c6363ac2d',
                        '279870e1-9d26-434f-9e45-795db2f3c6a1',
                        '770c56e3-b09f-4ec9-9763-8fb16c08e446',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '532f4c8a-2fbb-455a-be47-85c661d41b2c',
                        'a26e5ff8-fc21-47b9-8366-4c193835ed9e',
                        '1bca9adc-15a8-427d-94c3-3ded1f6c95d1',
                    ],
                    color: theme.colors.subjectBlue,
                },
            ]
        case Language.BrazilianPortuguese:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '68e38d3f-8b5d-4ee9-8cdb-15b261979103',
                        'a83d1463-be38-406b-9a5a-5e0385afd37f',
                        '26304927-907e-4a31-bb0a-1d4c08cbd111',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'Geografia',
                    iconType: 'world',
                    knowUuids: [
                        '0d0e366b-2b92-4f57-ac3a-6ba0e0cd0bca',
                        'f105eee8-c454-402a-956d-37f13f56cb5f',
                        'fd68411b-597f-42d6-bf6a-721b8ee8276e',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        '19881689-2060-44a9-9640-e71ab76f01f2',
                        '02a0aa68-d07f-4809-bbca-b722cca758b2',
                        '0810ec65-4633-4e8f-a3d0-0e5015270853',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        '9d8317a3-bde9-4d97-bb7f-f4b64b9d3e54',
                        '246d728b-a86d-42f0-b589-4d6952d4e08b',
                        '36648e62-6ea2-4f03-ad28-46f11d19fedf',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.Czech:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '3dd48db4-39ad-40a0-90de-75c9e4c08eb0',
                        '6b6bf1d8-fa4d-4c62-bb87-0718af493b3d',
                        'e6cbf956-f9af-4145-912f-42e1d7731b51',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectEnglish',
                    iconType: 'english',
                    knowUuids: [
                        'e4b81f21-e604-4c52-9827-9df4845828f7',
                        '5a9393b7-9cd4-4726-be48-7b8c0274d1f0',
                        '1b5dc840-f6ad-4368-83dc-67d9d42ff03b',
                    ],
                    color: theme.colors.subjectBlue,
                },
                {
                    titleKey: 'homepage/subjectChemistry',
                    iconType: 'chemistry',
                    knowUuids: [
                        'f5955e0e-9022-4ab7-a4aa-4f9dd3da37a5',
                        'efed5515-1d5d-4af2-80c9-0d6082cd53d1',
                        'c3d17135-848c-48f8-a612-7f44c3c19156',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: ['03bbc1e1-0bc7-415c-b1b0-4e64ed717b6d'],
                    color: theme.colors.subjectYellow,
                },
            ]
        case Language.Portuguese:
            return [
                {
                    titleKey: 'homepage/subjectMath',
                    iconType: 'math',
                    knowUuids: [
                        '1964bc94-4f4c-4156-bdd1-237b9b25a18f',
                        'f97550d1-e0e8-4cb5-b011-b826e9bbc1f4',
                        '262a939e-b0aa-46f8-9207-2a385b426326',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectHistory',
                    iconType: 'history',
                    knowUuids: [
                        '688da26c-7409-4707-8159-a5910c484213',
                        'c03498e2-5f6f-487b-95f0-be2f165e3de6',
                        'cf1f524c-b067-4de1-b4c9-3ec5c6c3186f',
                    ],
                    color: theme.colors.subjectYellow,
                },
                {
                    titleKey: 'Geografia',
                    iconType: 'world',
                    knowUuids: [
                        'ff327b10-c2ad-42a4-8bfc-07c6c675ab2f',
                        '195e1c1e-f98a-4ec8-8ea4-f39cf288b2f4',
                        '4fd73b36-138f-4370-b743-620d6c29dff4',
                    ],
                    color: theme.colors.subjectGreen,
                },
                {
                    titleKey: 'homepage/subjectBiology',
                    iconType: 'biology',
                    knowUuids: [
                        'dffd78a5-6ad3-4895-a13b-dc34db56cae0',
                        'e20e76f6-ae52-4a57-8533-7ac34219d082',
                        '1027aa8a-f182-4726-a0fd-eedfe1b631bc',
                    ],
                    color: theme.colors.subjectGreen,
                },
            ]
        case Language.Filipino:
            return []

        default:
            throw new Error(`Unknown language: ${contentLanguage}`)
    }
}
